<template>
  <div id="home">
    <nav class="navbar">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-main-collapse">
            <span class="glyphicon glyphicon-align-justify" aria-hidden="true"></span>
          </button>
        </div>
        <div class="navbar-collapse navbar-main-collapse collapse">
          <ul class="nav navbar-nav">
            <li><a href="#home">LeZhing</a></li>
            <li><a href="#guanli-box">管理后台</a></li>
            <li><a href="#youxi-box">游戏项目</a></li>
            <li><a href="#wxxcx-box">微信小程序</a></li>
            <li><a href="#zixun-box">咨询</a></li>
          </ul>
        </div>
      </div>
    </nav>


    <div class="content-purple" id="guanli-box">
      <div class="container">
        <div class="section-title text-center center">
          <h2>管理后台</h2>
          <hr>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="inner-list-one">
              <a href="http://laylar.lezhing.com" target="_blank">
                <img src="@/assets/img/laylar.png">
                <h3>LayLar</h3>
                <p></p>
              </a>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="inner-list-one">
              <a href="http://laytap.lezhing.com" target="_blank">
                <img src="@/assets/img/laytap.png">
                <h3>LayTap</h3>
                <p></p>
              </a>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="inner-list-one">
              <a href="http://fad.lezhing.com" target="_blank">
                <img src="@/assets/img/fad.png">
                <h3>Fad</h3>
                <p></p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-white" id="youxi-box">
      <div class="container">
          <div class="section-title text-center center">
            <h2>游戏项目</h2>
            <hr>
          </div>
          <div class="row">
            <div class="col-md-4">
                <div class="inner-list-one">
                    <a href="http://xxlstar.lezhing.com" target="_blank">
                        <img src="@/assets/img/xxlstar.png">
                        <h3>星星消消乐</h3>
                        <p>数数天上的星星有多少</p>
                    </a>
                </div>
            </div>
            <div class="col-md-4">
              <div class="inner-list-one">
                <a href="http://3y.lezhing.com/second" target="_blank">
                  <img src="@/assets/img/second.png">
                  <h3>一秒有多长</h3>
                  <p>测测你感觉中的一秒有多长</p>
                </a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="inner-list-one">
                <a href="http://3y.lezhing.com/paint.html" target="_blank">
                  <img src="@/assets/img/paint.png">
                  <h3>在线画图</h3>
                  <p>即兴创作，留下记忆</p>
                </a>
              </div>
            </div>
          </div>
        <div class="row">
          <div class="col-md-4">
            <div class="inner-list-one">
              <a href="http://3y.lezhing.com/pintu" target="_blank">
                <img src="@/assets/img/pintu.png">
                <h3>拼图</h3>
                <p>在线拼图，享受指尖节奏</p>
              </a>
            </div>
          </div>
          <div class="col-md-4">
            <div class="inner-list-one">
               <a href="http://dota.lezhing.com" target="_blank">
                <img src="@/assets/img/dota.png">
                <h3 style="padding: 22px 0;">DOTA</h3> 
              </a>
            </div>
          </div>
          <div class="col-md-4">
            <div class="inner-list-one">
              <a href="http://xxlface.lezhing.com" target="_blank">
                <img src="@/assets/img/xxlsg.png">
                <h3>水果消消乐</h3>
                <p>好吃个没完没了</p>
              </a>
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-md-4">
              <div class="inner-list-one">
                  <img src="@/assets/img/huapai1.png">
                  <h3>花牌</h3>
                  <p>谷歌应用商店，韩国区，搜索 행운맞고 下载游戏</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="inner-list-one">
                  <img src="@/assets/img/huapai2.png">
                  <h3>花牌</h3>
                  <p></p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="inner-list-one">
                  <img src="@/assets/img/huapai3.png">
                  <h3>花牌</h3>
                  <p>精彩对战，尽情体验</p>
              </div>
            </div>
          </div>
      </div>
    </div>


    <div class="content-purple" id="wxxcx-box">
      <div class="container">
        <div class="section-title text-center center">
          <h2>微信小程序</h2>
          <hr>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <div class="inner-list-one">
              <img src="@/assets/img/tiaojiu.png">
              <h3>蜩鸠</h3>
              <p>森林之中，蜩鸠之乐</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="inner-list-one">
                <img src="@/assets/img/yizhidao.png">
                <h3>一指刀</h3>
                <p>淡淡一指，轻松决定</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="inner-list-one">
                <img src="@/assets/img/caihongwoniu.png">
                <h3>彩虹蜗牛</h3>
                <p>彩红蜗牛，丈量生活</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="inner-list-one">
              <img src="@/assets/img/diandi.png">
              <h3>点滴计数</h3>
              <p>解放双手，轻松计数</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="inner-list-one">
              <img src="@/assets/img/leleqin.jpg">
              <h3>乐乐电子琴</h3>
              <p>乐乐(leyue)电子琴，享受节奏</p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="inner-list-one">
              <img src="@/assets/img/lelegu.jpg">
              <h3>乐乐架子鼓</h3>
              <p>摇摆摇摆，尽情摇摆</p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="inner-list-one">
              <img src="@/assets/img/leleren.jpg">
              <h3>乐乐背景乐</h3>
              <p>重温经典，重拾记忆</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer" id="zixun-box">
      <div class="container">
        <div class="row row-pb-md">
          <div class="col-md-4">
            <h4>简介</h4>
            <p>LEZHING 工作室，专注互联网项目开发。</p>
          </div>
          <div class="col-md-4 col-md-push-1">
            <h4>菜单</h4>
            <ul class="footer-links">
              <li><a href="#home">LEZHING</a></li>
              <li><a href="#guanli-box">管理后台</a></li>
              <li><a href="#youxi-box">游戏项目</a></li>
              <li><a href="#wxxcx-box">微信小程序</a></li>
              <li><a href="#zixun-box">咨询</a></li>
            </ul>
          </div>

          <div class="col-md-4 col-md-push-1">
            <h4>联系方式</h4>
            <ul class="footer-links">
              <li><a href="qq://:1428837023">1428837023</a></li>
              <li><a href="mailto:1428837023@qq.com">1428837023@qq.com</a></li>
              <li><a href="http://www.lezhing.com">lezhing.com</a></li>
            </ul>
          </div>

        </div>
        <div class="row copyright">
          <div class="col-md-12 text-center">
            <p>
              <small class="block">Copyright © 2024.lezhing.com All rights reserved.</small>
              <small class="block"></small>
            </p>
            <p></p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    export default {
        name: "Home",
    }
</script>

<style scoped>
  @import '../assets/css/home.css';
</style>



// WEBPACK FOOTER //
// src/components/Home.vue